const UserReports = () => {
  return (
    <>
      UserReports
    </>
  );
};

export default UserReports;